<template>
  <div>
    <div class="package-buy" v-if="!isChosePay">
      <h3 class="title">服务名称</h3>
      <div class="package-type">
        <div class="name">{{ $store.state.packageDetail.packageName }}</div>
        <div class="info">
          <p>{{ $store.state.packageDetail.defaultTemplate }}个默认模板</p>
          <p v-if="$store.state.packageDetail.resend">
            {{ $store.state.packageDetail.resend ? '可重发' : '' }}
          </p>
          <p v-if="$store.state.packageDetail.recall">
            {{ $store.state.packageDetail.recall ? '可撤回' : '' }}
          </p>
        </div>
        <div class="info">
          <p>{{ $store.state.packageDetail.customTemplate }}个定制模板</p>
          <p v-if="$store.state.packageDetail.smsNotify">
            {{ $store.state.packageDetail.smsNotify ? '短信发送' : '' }}
          </p>
          <p v-if="$store.state.packageDetail.wechatNotify">
            {{
              $store.state.packageDetail.wechatNotify ? '微信公众号发送' : ''
            }}
          </p>
        </div>
        <div class="info">
          <p>邮件发送</p>
          <p v-if="$store.state.packageDetail.oaNotify">
            {{ $store.state.packageDetail.oaNotify ? 'OA系统通知' : '' }}
          </p>
        </div>
      </div>
      <h3 class="title">服务时间</h3>
      <div class="package-type">
        <div v-if="$store.state.vipActiveData.length">
          <!-- vip -->
          <el-select v-model="year" @change="handleYearChange" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <span class="tips" v-if="createTime">{{
            createTime.toISOString().slice(0, 10) +
            ' 至 ' +
            endTime.toISOString().slice(0, 10)
          }}</span>
        </div>
        <div v-else>
          <!-- 普通 -->
          <el-select v-model="year" @change="handleYearChangePackage" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <span class="tips" v-if="createTime">{{
            createTime.toISOString().slice(0, 10) +
            ' 至 ' +
            endTime.toISOString().slice(0, 10)
          }}</span>
        </div>
      </div>
      <div>
        <div v-if="$store.state.vipActiveData.length">
          <h3 class="title">购买条数</h3>
          <!-- {{$store.state.vipActiveData[0]}} -->
          <p style="padding-bottom: 10px">
            月条数
            <span style="width: 200px; display: inline-block">
              <el-input maxlength="6" v-model="vipNum"></el-input>
            </span>
            <span> x {{ year * 12 }}个月</span>
          </p>
          <span style="color: red" v-show="isBtn">VIP套餐最低需购买{{
              $store.state.vipActiveData[0].lowerLimit
                ? $store.state.vipActiveData[0].lowerLimit
                : 200
            }}条/月(且为正整数)</span>
          <div class="charge-container" :style="{
              width: 150 * ($store.state.vipActiveData.length + 1) + 'px',
            }">
            <div v-for="i in $store.state.vipActiveData">
              <h4>{{ i.lowerLimit + '-' + i.upperLimit }}条</h4>
              <p class="price">
                {{ i.price }}<span style="font-size: 14px">元</span>
              </p>
              <p class="name">工资条</p>
            </div>
            <div>
              <h4>1600条以上</h4>
              <p class="name" style="margin-top: 20px">请联系客服</p>
            </div>
          </div>
          <div class="totle">
            <!-- <p style="color:red;padding-bottom:10px" v-if="packageTotal||rechargeTotal">
              *有未支付订单，取消后退回余额，查看
              <span
                style="color:#3BC492; cursor: pointer;"
                @click="handleToOrderList"
              >订单列表</span>
            </p> -->
            <el-checkbox v-model="checked">从账户余额中抵扣</el-checkbox>
            <span style="display: inline-block; margin-left: 20px">
              <el-input style="display: inline-block" :disabled="true" :placeholder="balance"></el-input>
            </span>
            <h2>总计: ￥{{ vipTotal.toFixed(2) }}</h2>
            <div class="btn-container">
              <div class="paybtn">
                <el-button class="login-btn" type="primary" :disabled="isBtn || !infoflag" @click="handleToPay(vipTotal, 'vip')">立即支付</el-button>
                <div class="infocheckbox">
                  <el-checkbox v-model="infoflag"></el-checkbox>
                  <p>
                    我已查阅并同意
                    <span @click="showinfo" style="color: #3bc492; cursor: pointer">《 悦享工资条短信服务协议 》</span>
                  </p>
                </div>
              </div>

              <p>
                *
                注：企业有待支付订单，点击立即支付后，待支付订单将会自动被取消，查看
                <span style="color: #3bc492; cursor: pointer" @click="handleToOrderList">订单列表</span>
              </p>
            </div>
          </div>
        </div>
        <div class="package-buy" v-else>
          <h3 class="title">金额</h3>
          <div>
            <div class="package-type">
              <div class="name">
                ￥{{
                  $store.state.packageDetail.price *
                  $store.state.packageDetail.upperLimit
                }}/年
              </div>
              <div class="info">
                <p>
                  平均{{ $store.state.packageDetail.price.toFixed(2) }}元/条
                </p>
              </div>
              <div class="info">
                <p>* 预定购，1年起订</p>
              </div>
            </div>
            <div class="totle">
              <!-- <p>普通</p> -->
              <!-- <p style="color:red;padding-bottom:10px" v-if="packageTotal||rechargeTotal">
                *有未支付订单，取消后退回余额，查看
                <span
                  style="color:#3BC492; cursor: pointer;"
                  @click="handleToOrderList"
                >订单列表</span>
              </p> -->
              <el-checkbox v-model="checked">从账户余额中支付</el-checkbox>
              <span style="display: inline-block; margin-left: 20px">
                <el-input style="display: inline-block" :disabled="true" :placeholder="`余额${balance}元`"></el-input>
              </span>
              <h2>总计: ￥{{ total.toFixed(2) }}</h2>
              <div class="btn-container">
                <div class="paybtn">
                  <el-button class="login-btn" type="primary" :disabled="!infoflag" @click="handleToPay(total, 'package')">立即支付</el-button>
                  <div class="infocheckbox">
                    <el-checkbox v-model="infoflag"></el-checkbox>
                    <p>
                      我已查阅并同意
                      <span @click="showinfo" style="color: #3bc492; cursor: pointer">《 悦享工资条短信服务协议 》</span>
                    </p>
                  </div>
                </div>

                <p>
                  *
                  注：企业有待支付订单，点击立即支付后，待支付订单将会自动被取消，查看
                  <span style="color: #3bc492; cursor: pointer" @click="handleToOrderList">订单列表</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 用户协议 -->
    <el-dialog :visible.sync="checkVisible" :close-on-click-modal="false">
      <div class="reg-text">
        <h4>
          <span>悦享工资条短信服务协议</span>
        </h4>
        <p>欢迎您使用悦享工资条短信服务！</p>
        <p>
          为使用悦享工资条短信服务，您应当阅读并遵守《悦享工资条短信服务协议》（以下简称“本协议”）。
          在接受本协议之前，请您务必仔细阅读本协议的全部内容，特别是免除或者限制责任的条款以及管辖法院的选择条款等。限制或免责条款可能以加粗或加下划线的形式提示您重点注意。
        </p>
        <p class="p-weight">
          无论是否实际阅读本协议，您实际使用悦享工资条平台服务，
          均表示您与悦享工资条已就本协议达成一致并同意接受本协议的全部约定内容。
          如果您不同意本协议的任意内容，或者无法准确理解悦享工资条对条款的解释，请不要同意本协议或使用本协议项下的服务。
          否则，表示您已接受了以下所述的条款和条件，同意受本协议约束。
          如您有违反本协议的任何行为时，悦享工资条有权依照本协议随时单方采取限制、中止或终止向您提供服务，或者采取封号（且不再开通）等措施；已订购的套餐包，无论是否已经使用，一律不允许退订/退款；造成严重影响或后果的，悦享工资条将有权追究您的相关法律责任。
        </p>
        <h3>定义</h3>
        <p>
          悦享工资条短信服务：向您提供的通道，可以支持在悦享工资条平台为全国范围内手机短信在您、电信运营商与手机终端用户之间的发送、接收功能。
        </p>
        <h3>服务功能</h3>
        <p>
          悦享工资条提供的短信服务，具体包括短信验证码、工资条查看短信通知、工资条签收短信通知、工资条剩余条数不足短信通知等功能。
        </p>
        <h3>服务费用</h3>
        <p>本协议内所及短信，按实际发送的工资条条数计费。</p>
        <p>工资条计费规则及详细价格，以平台公布的规则及价格为准。</p>
        <p>
          若因运营商计费规则变化导致悦享工资条短信服务调整计费标准，悦享工资条会提前官网告示或以邮件、微信、电话等方式告知您，若您继续使用悦享工资条服务则需按悦享工资条公布的收费标准支付费用。
        </p>
        <p class="p-weight">
          您应已明确知晓本平台短信的功能用途和发送范围，且通过在线购买的套餐包为享受套餐优惠后的打包价格；除非悦享工资条公告停止相应服务或明确告知您可以退款外，否则一经充值或购买，无论是否已经使用，一律不允许退订/退款。
        </p>
        <h3>服务使用规范</h3>
        <p>
          您使用悦享工资条短信服务的通道只能向您内部员工或其他特定的人群（以下统称为“用户”）发送短信，发送的内容应符合您所使用产品设计功能规定的发送用途，您应当事先获得用户明确同意，方可向用户发送短信。
        </p>
        <p>
          悦享工资条有权对您发送短信进行监督、审核和监测，对于未审核通过的短信文案内容，悦享工资条将限制发送，且悦享工资条有权单方判断和决定您发送短信是否违反本协议，并有权拒绝发送违反法律规定或本协议约定的短信内容，一经发现您发送违反法律规定或本协议约定的信息，有权立即停止传输，一旦发现您使用本服务的行为违反法律规定或本协议约定行为，有权停止服务或解除协议。如果因您的原因导致用户投诉使悦享工资条短信服务所使用的短信通道存在被运营商停用风险，悦享工资条有权要求停止服务并要求您对悦享工资条所受一切损失承担赔偿责任。
        </p>
        <p>
          您保证向用户所发送的短信的内容真实、准确、合法，您不得利用悦享工资条短信服务提供的通道从事下列行为：
          4.1 违反国家法律、法规和行业政策开展业务。 4.2
          向用户发送违反国家法律、法规、国家政策和公序良俗的信息。 4.3
          向用户发送政治类信息、违法犯罪信息、涉黄信息、SP诱骗定制信息或第三方广告或其它违法违规信息。
          4.4
          未经客户允许向其发送商业广告或其他信息：如房地产广告、发票、投资、理财、股票、收藏品、移民信息等。
          4.5 发布可能产生重大负面社会影响的短信。 4.6
          违反《互联网信息服务管理办法》第十五条的规定，发送含有以下内容的信息（“九不准”）：（1）反对宪法所确定的基本原则的；（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；（3）损害国家荣誉和利益的；（4）煽动民族仇恨、民族歧视，破坏民族团结的；（5）破坏国家宗教政策，宣扬邪教和封建迷信的；（6）散布谣言，扰乱社会秩序，破坏社会稳定的；（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；（8）侮辱或者诽谤他人，侵害他人合法权益的；（9）含有法律、行政法规禁止的其他内容的。
          4.7
          违反中华人民共和国公安部发出的《关于依法开展治理手机违法短信息有关工作的通知》（公通字【2005】77号），发送含有以下内容的信息：
          （1）假冒银行或银联名义进行诈骗或者敲诈勒索公私财物的信息；
          （2）散布淫秽、色情、赌博、暴力、凶杀、恐怖内容或者教唆犯罪、传授犯罪方法的信息；
          （3）非法销售枪支、弹药、爆炸物、走私车、毒品、迷魂药、淫秽物品、假钞假发票或者明知是犯罪所得赃物的信息；
          （4）发布假中奖、假婚介、假招聘，或者引诱、介绍他人卖淫嫖娼的信息；
          （5）多次发送干扰他人正常生活的，以及含有其他违反宪法、法律、行政法规禁止性规定内容的信息。
          4.8 其他违反国家法律、法规和行业政策的行为。
        </p>
        <h3>悦享工资条平台权利义务</h3>
        <p>
          悦享工资条短信服务有权监督您在其通道内，短信发送的范围及内容，对于您违反法律、法规或《短信审核标准》的规定，利用悦享工资条短信服务通道向不适当的用户发送短信，或发送内容不当的短信的，悦享工资条主体单位有权追究您的违约责任。
          悦享工资条短信服务应对您存留在其通道中的客户信息（包括但不限于客户姓名、手机号码等信息）进行保密，并不得利用悦享工资条短信服务信息技术和设备便利提取各项信息或用将上述信息用于本协议约定以外的任何用途。否则，您有权追究悦享工资条短信服务的违约责任。
        </p>
        <h3>服务可审查性</h3>
        <p>
          悦享工资条在依据现有法律法规体系下，出于配合政府监管部门的监管或安全取证调查等原因的需要，在符合流程和手续完备的情况下，可以提供客户所使用的服务的相关信息，包括关键组件的运行日志、运维人员的操作记录、客户操作记录等信息。
        </p>
        <h3>故障恢复能力</h3>
        <p>
          悦享工资条提供专业团队7 ×
          24小时全面维护，并以工单和电话保障等方式提供技术支持，具备完善的故障监控、告警、定位及故障恢复能力。
        </p>
        <h3>免责条款</h3>
        <p>
          您应了解，使用悦享工资条的短信服务通道涉及到电信运营商和因特网的网络服务，可能会受到各个环节不稳定因素的影响，因此您同意，对因停电、计费系统故障、计算机错误或病毒、黑客攻击、被盗刷、数据丢失或其它在悦享工资条平台合理控制范围之外的原因所造成的中断、延迟或停顿等服务问题，悦享工资条平台及其主体单位不承担责任。
          悦享工资条有权定期或不定期地对提供网络服务的网站或相关的设备进行检修或者维护，如因此类情况而造成网络服务在合理时间内的中断或暂停，悦享工资条无需为此承担任何责任。
        </p>
        <p>
          如发生下述任一情况而导致服务中断及您损失的，悦享工资条不承担责任：
          （1）发生不可抗力情形的。 （2）黑客攻击、计算机病毒侵入或发作的。
          （3）计算机系统遭到破坏、瘫痪或无法正常使用的。
          （4）因政府管制而造成中止或终止服务的。
          （5）其它非因悦享工资条的过错而引起的。
        </p>
        <p>
          对于您违反法律、法规或《短信审核标准》的规定，利用悦享工资条短信服务通道向不适当的用户发送短信，或发送内容不当的短信的，造成的法律责任一概由您承担。
          在任何情况下，悦享工资条对本协议项下提供的服务所承担的违约赔偿责任总额不超过违约服务对应之服务费总额。
        </p>
        <p>
          在任何情况下，悦享工资条均不就因使用悦享工资条提供的服务所发生的任何间接性、后果性、惩戒性、偶然性、特殊性的损害，包括您使用悦享工资条服务而遭受的利润损失承担责任（即使您已事先被告知该等损害发生的可能性）。
        </p>
        <h3>保密条款</h3>
        <p>
          本协议及本协议任何一方因协议的履行而获得或知悉的对方的任何资料和信息均视为保密信息，双方相互负有保密义务。任何一方未经对方书面同意，不可将上述保密信息以任何方式向第三方披露或用于本协议以外的其他事项，但法律、法规另有规定或监管部门另有要求的除外。
          本保密条款将持续有效。本协议或其中任何条款的终止、中止、失效、无效均不影响本保密条款的效力。
        </p>
        <h3>其他</h3>
        <p>
          悦享工资条有权根据变化对该协议的部分服务条款进行改变。涉及到客户使用的变更会以公告形式进行推送。
        </p>
      </div>

      <!-- <el-button @click="onArgeen('dis')">不同意</el-button>
      <el-button @click="onArgeen('ok')">同意</el-button>-->
      <div style="text-align: center; margin-top: 20px">
        <el-button @click="onArgeen" class="login-btn" style="width: 350px" type="primary">同 意</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import chosePay from './chosePay.vue'
import { totalmem } from 'os'
import { constants } from 'crypto'
import { customerOrder, rechargeOrder } from '@/api/setUp.js'
export default {
  name: 'index',
  props: {},
  components: {
    chosePay,
  },
  data () {
    return {
      checkVisible: false,
      isTipsShow: false,
      userInfo: {},
      isChosePay: false,
      checked: false,
      balance: 0,
      year: 1,
      total: 100,
      vipNum: '',
      vipTotal: 0,
      createTime: '',
      endTime: '',
      isBtn: true,
      packageTotal: 0,
      rechargeTotal: 0,
      infoflag: true,
      options: [
        {
          value: 1,
          label: '1年',
        },
        {
          value: 2,
          label: '2年',
        },
        {
          value: 3,
          label: '3年',
        },
        {
          value: 4,
          label: '4年',
        },
        {
          value: 5,
          label: '5年',
        },
      ],
    }
  },
  methods: {
    showinfo () {
      this.checkVisible = true
    },
    onArgeen () {
      this.checkVisible = false
      this.infoflag = true
    },
    handleToOrderList () {
      this.$router.replace('/index/order')
    },
    handleYearChange (val) {
      console.log('cccc1111111', val)
      this.year = val
      // if (this.$store.state.vipActiveData[4] &&this.vipNum >= this.$store.state.vipActiveData[4].lowerLimit) {
      //           this.isBtn = false;
      //           this.vipTotal =
      //                   this.$store.state.vipActiveData[4].price *
      //                   this.vipNum *
      //                   this.year *
      //                   12;
      //         }else if (this.$store.state.vipActiveData[3] &&this.vipNum >= this.$store.state.vipActiveData[3].lowerLimit) {
      //           this.isBtn = false;
      //           this.vipTotal =
      //                   this.$store.state.vipActiveData[3].price *
      //                   this.vipNum *
      //                   this.year *
      //                   12;
      //         }else

      if (
        this.$store.state.vipActiveData[2] &&
        this.vipNum >= this.$store.state.vipActiveData[2].lowerLimit
      ) {
        console.log(1, this.year == 1)
        this.isBtn = false
        this.vipTotal =
          this.year == 1 ? this.$store.state.vipActiveData[2].price *
            this.vipNum *
            this.year *
            12 * 0.9 : this.$store.state.vipActiveData[2].price *
            this.vipNum *
            this.year *
            12 * 0.8
        console.log(this.vipTotal)
      } else if (
        this.$store.state.vipActiveData[1] &&
        this.vipNum >= this.$store.state.vipActiveData[1].lowerLimit
      ) {
        console.log(2, this.year == 1)
        this.vipTotal =
          this.year == 1 ? this.$store.state.vipActiveData[1].price *
            this.vipNum *
            this.year *
            12 * 0.9 :
            this.$store.state.vipActiveData[1].price *
            this.vipNum *
            this.year *
            12 * 0.8
        this.isBtn = false
        console.log(this.vipTotal)
      } else if (
        this.$store.state.vipActiveData[0] &&
        this.vipNum >= this.$store.state.vipActiveData[0].lowerLimit
      ) {
        console.log(3, this.year == 1)
        this.vipTotal =
          this.year == 1 ? this.$store.state.vipActiveData[0].price *
            this.vipNum *
            this.year *
            12 * 0.9 :
            this.$store.state.vipActiveData[0].price *
            this.vipNum *
            this.year *
            12 * 0.8
        this.isBtn = false
        console.log(this.vipTotal)
      } else {
        this.vipTotal = 0
        this.isBtn = true
      }

      this.endTime = new Date(
        new Date(this.createTime).setFullYear(
          new Date(this.createTime).getFullYear() + this.year
        )
      )
    },
    handleYearChangePackage (val) {
      console.log('c1c1c1', val)
      this.total =
        this.$store.state.packageDetail.price *
        this.$store.state.packageDetail.upperLimit *
        val
      if (val == 1) {
        console.log('一年', this.total * 0.9)
        this.total =
          this.$store.state.packageDetail.price *
          this.$store.state.packageDetail.upperLimit *
          val * 0.9
      }
      if (val >= 2) {
        console.log('两年以上', this.total * 0.8)
        this.total =
          this.$store.state.packageDetail.price *
          this.$store.state.packageDetail.upperLimit *
          val * 0.8
      }
      this.year = val
      this.endTime = new Date(
        new Date(this.createTime).setFullYear(
          new Date(this.createTime).getFullYear() + this.year
        )
      )
    },
    iscarryonVipPay (val) {
      if (this.$route.query.endtime) {
        //继续购买vip
        this.$http
          .post('/salary-service/customer/orderAdd', {
            content: this.$store.state.packageDetail.packageName,
            createdName: this.userInfo.contact,
            expireTime: this.endTime,
            beginTime: this.$route.query.starttime,
            balancePay: true,
            balancePayAmount: val,
            operator: this.userInfo.id,
            orderNum: this.vipNum * this.year * 12,
            payAmount: 0,
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.$store.commit('orderStepBack')
              this.$router.replace({ path: '/index/new' })
              this.$notify({
                title: '成功',
                message: '余额购买成功',
                type: 'success',
              })
            } else {
              this.$notify({
                title: '警告',
                message: res.data.msg,
                type: 'error',
              })
            }
          })
          .catch((e) => { })
      } else {
        //首次购买
        this.$http
          .post('/salary-service/customer/orderAdd', {
            content: this.$store.state.packageDetail.packageName,
            createdName: this.userInfo.contact,
            beginTime: new Date(),
            expireTime: new Date(
              date.setFullYear(date.getFullYear() + this.year)
            ),
            balancePay: true,
            balancePayAmount: val,
            operator: this.userInfo.id,
            orderNum: this.vipNum * this.year * 12,
            payAmount: 0,
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.$store.commit('orderStepBack')
              this.$router.replace({ path: '/index/new' })
              this.$notify({
                title: '成功',
                message: '余额购买成功',
                type: 'success',
              })
            } else {
              this.$notify({
                title: '警告',
                message: res.data.msg,
                type: 'error',
              })
            }
          })
      }
    },

    handleToPay (val, type) {
      console.log('ccccccccc11', val, type)
      let date = new Date()
      if (type == 'vip') {
        if (this.checked) {
          if (val <= this.balance) {
            console.log('engtho')
            this.$confirm('将会从余额中扣除待付金额，是否确定', '提示', {
              closeOnClickModal: false,
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(() => {
                // this.iscarryonVipPay(val);
                if (this.$route.query.endtime) {
                  console.log(this.$route.query.infoid, '继续购买vip')
                  //继续购买vip
                  this.$http
                    .post('/salary-service/customer/orderAdd', {
                      content: this.$store.state.packageDetail.packageName,
                      createdName: this.userInfo.contact,
                      // expireTime: this.endTime,
                      // beginTime: this.$route.query.starttime,
                      balancePay: true,
                      // balancePayAmount: val,
                      operator: this.userInfo.id,
                      orderNum: this.vipNum * this.year * 12,
                      serviceTime: this.year,
                      // payAmount: 0
                    })
                    .then((res) => {
                      if (res.data.code == 200) {
                        this.$store.commit('orderStepBack')
                        this.$router.replace({ path: '/index/new' })
                        this.$notify({
                          title: '成功',
                          message: '余额购买成功',
                          type: 'success',
                        })
                      } else {
                        this.$notify({
                          title: '警告',
                          message: res.data.msg,
                          type: 'error',
                        })
                      }
                    })
                    .catch((e) => { })
                } else {
                  //首次购买
                  console.log(this.$route.query.infoid, '首次购买vip')
                  this.$http
                    .post('/salary-service/customer/orderAdd', {
                      content: this.$store.state.packageDetail.packageName,
                      createdName: this.userInfo.contact,
                      // beginTime: new Date(),
                      // expireTime: new Date(
                      //   date.setFullYear(date.getFullYear() + this.year)
                      // ),
                      balancePay: true,
                      // balancePayAmount: val,
                      operator: this.userInfo.id,
                      orderNum: this.vipNum * this.year * 12,
                      serviceTime: this.year,
                      // payAmount: 0
                      infoId: this.$route.query.infoid,
                    })
                    .then((res) => {
                      if (res.data.code == 200) {
                        this.$store.commit('orderStepBack')
                        this.$router.replace({ path: '/index/new' })
                        this.$notify({
                          title: '成功',
                          message: '余额购买成功',
                          type: 'success',
                        })
                      } else {
                        this.$notify({
                          title: '警告',
                          message: res.data.msg,
                          type: 'error',
                        })
                      }
                    })
                }
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消支付',
                })
              })
          } else {
            this.$message({
              type: 'info',
              message: '余额不足，请先充值',
            })
          }
        } else {
          if (this.$route.query.endtime) {
            this.$http
              .post('/salary-service/customer/orderAdd', {
                content: this.$store.state.packageDetail.packageName,
                createdName: this.userInfo.contact,
                // expireTime: this.endTime,
                // beginTime: this.$route.query.starttime,
                balancePay: false,
                // balancePayAmount: 0,
                operator: this.userInfo.id,
                orderNum: this.vipNum * this.year * 12,
                serviceTime: this.year,
                // payAmount: val.toFixed(2)
              })
              .then((res) => {
                if (res.data.code == 200) {
                  this.$store.commit('orderStepBack')
                  this.$router.push({
                    name: 'chosePayment',
                    query: { total: val.toFixed(2), orderNum: res.data.data },
                  })
                } else {
                  this.$notify({
                    title: '警告',
                    message: res.data.msg,
                    type: 'error',
                  })
                }
              })
              .catch((e) => { })
          } else {
            this.$http
              .post('/salary-service/customer/orderAdd', {
                content: this.$store.state.packageDetail.packageName,
                createdName: this.userInfo.contact,
                // beginTime: new Date(),
                // expireTime: new Date(
                //   date.setFullYear(date.getFullYear() + this.year)
                // ),
                balancePay: false,
                // balancePayAmount: 0,
                operator: this.userInfo.id,
                orderNum: this.vipNum * this.year * 12,
                serviceTime: this.year,
                // payAmount: val.toFixed(2)
              })
              .then((res) => {
                if (res.data.code == 200) {
                  this.$store.commit('orderStepBack')
                  this.$router.push({
                    name: 'chosePayment',
                    query: { total: val.toFixed(2), orderNum: res.data.data },
                  })
                } else {
                  this.$notify({
                    title: '警告',
                    message: res.data.msg,
                    type: 'error',
                  })
                }
              })
              .catch((e) => { })
          }
        }
      } else {
        if (this.checked) {
          if (val <= this.balance) {
            this.$confirm('将会从余额中扣除待付金额，是否确定', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              type: 'warning',
            })
              .then(() => {
                if (this.$route.query.endtime) {
                  //再次购买套餐
                  console.log(this.$route.query.infoid, '再次购买其他类型套餐')
                  this.$http
                    .post('/salary-service/customer/orderAdd', {
                      content: this.$store.state.packageDetail.packageName,
                      createdName: this.userInfo.contact,
                      // expireTime: this.endTime,
                      // beginTime: this.$route.query.starttime,
                      balancePay: true,
                      // balancePayAmount: val,
                      operator: this.userInfo.id,
                      orderNum:
                        this.$store.state.packageDetail.upperLimit * this.year,
                      serviceTime: this.year,
                      // payAmount: 0
                    })
                    .then((res) => {
                      console.log('shide')
                      if (res.data.code == 200) {
                        this.$store.commit('orderStepBack')
                        this.$router.replace({ path: '/index/new' })
                        this.$notify({
                          title: '成功',
                          message: '余额购买成功',
                          type: 'success',
                        })
                      } else {
                        this.$notify({
                          title: '警告',
                          message: res.data.msg,
                          type: 'error',
                        })
                      }
                    })
                    .catch((e) => { })
                } else {
                  //首次购买套餐
                  console.log(this.$route.query.infoid, '首次购买其他类型套餐')
                  this.$http
                    .post('/salary-service/customer/orderAdd', {
                      content: this.$store.state.packageDetail.packageName,
                      createdName: this.userInfo.contact,
                      // expireTime: new Date(
                      //   date.setFullYear(date.getFullYear() + this.year)
                      // ),
                      // beginTime: new Date(),
                      balancePay: true,
                      // balancePayAmount: val,
                      operator: this.userInfo.id,
                      orderNum:
                        this.$store.state.packageDetail.upperLimit * this.year,
                      serviceTime: this.year,
                      // payAmount: 0
                      infoId: this.$route.query.infoid,
                    })
                    .then((res) => {
                      if (res.data.code == 200) {
                        this.$store.commit('orderStepBack')
                        this.$router.replace({ path: '/index/new' })
                        this.$notify({
                          title: '成功',
                          message: '余额购买成功',
                          type: 'success',
                        })
                      } else {
                        this.$notify({
                          title: '警告',
                          message: res.data.msg,
                          type: 'error',
                        })
                      }
                    })
                    .catch((e) => { })
                }
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消支付',
                })
              })
          } else {
            this.$message({
              type: 'info',
              message: '余额不足，请先充值',
            })
          }
        } else {
          console.log('非余额套餐支付', val)
          //非余额套餐支付
          if (this.$route.query.endtime) {
            this.$http
              .post('/salary-service/customer/orderAdd', {
                content: this.$store.state.packageDetail.packageName,
                createdName: this.userInfo.contact,
                // expireTime: this.endTime,
                // beginTime: this.$route.query.starttime,
                balancePay: false,
                // balancePayAmount: 0,
                operator: this.userInfo.id,
                orderNum:
                  this.$store.state.packageDetail.upperLimit * this.year,
                serviceTime: this.year,
                // payAmount: val.toFixed(2)
              })
              .then((res) => {
                if (res.data.code == 200) {
                  this.$store.commit('orderStepBack')
                  this.$router.push({
                    name: 'chosePayment',
                    query: { total: val.toFixed(2), orderNum: res.data.data },
                  })
                } else {
                  this.$notify({
                    title: '警告',
                    message: res.data.msg,
                    type: 'error',
                  })
                }
              })
              .catch((e) => { })
          } else {
            this.$http
              .post('/salary-service/customer/orderAdd', {
                content: this.$store.state.packageDetail.packageName,
                createdName: this.userInfo.contact,
                // expireTime: new Date(
                //   date.setFullYear(date.getFullYear() + this.year)
                // ),
                // beginTime: new Date(),
                balancePay: false,
                // balancePayAmount: 0,
                operator: this.userInfo.id,
                orderNum:
                  this.$store.state.packageDetail.upperLimit * this.year,
                serviceTime: this.year,
                // payAmount: val.toFixed(2)
              })
              .then((res) => {
                if (res.data.code == 200) {
                  this.$store.commit('orderStepBack')
                  this.$router.push({
                    name: 'chosePayment',
                    query: { total: val.toFixed(2), orderNum: res.data.data },
                  })
                } else {
                  this.$notify({
                    title: '警告',
                    message: res.data.msg,
                    type: 'error',
                  })
                }
              })
              .catch((e) => { })
          }
        }
      }
    },
    async getUserBalance () {
      let res = await this.$http.get(`salary-service/customer/balance`)

      this.balance = res.data
    },
    async getUserAllOrder () {
      this.$http
        .post('salary-service/customer/recharge_order/pager', {
          pageNumber: 0,
          size: 10,
          state: 0,
        })
        .then((res) => {
          this.rechargeTotal = +res.headers['x-total-count']
        })

      const res = await customerOrder({
        pageNumber: 0,
        size: 10,
        state: 0,
      })
      this.packageTotal = +res.headers['x-total-count']
    },
  },

  mounted () {
    // this.createTime = this.$route.query.endtime
    //   ? new Date(this.$route.query.endtime)
    //   : new Date();
    this.createTime = new Date()
    console.log(this.createTime, 'this.createTime')
    this.endTime = new Date(
      new Date(this.createTime).setFullYear(
        new Date(this.createTime).getFullYear() + this.year
      )
    )
    // this.endTime = this.$route.query.endtime
    //   ? new Date(
    //       new Date(this.$route.query.endtime).setFullYear(
    //         new Date(this.$route.query.endtime).getFullYear() + this.year
    //       )
    //     )
    //   : new Date(
    //       new Date(this.createTime).setFullYear(
    //         new Date(this.createTime).getFullYear() + this.year
    //       )
    //     );
    this.getUserAllOrder()
    this.getUserBalance()
    this.total =
      this.$store.state.packageDetail.price *
      this.$store.state.packageDetail.upperLimit *
      this.year * 0.9
  },

  watch: {
    vipNum: function (val) {
      let boolean = new RegExp('^[1-9][0-9]*$').test(this.vipNum)
      // if (boolean && this.$store.state.vipActiveData[4] && val >= this.$store.state.vipActiveData[4].lowerLimit) {
      //   this.isBtn = false;
      //   this.vipTotal =
      //     this.$store.state.vipActiveData[4].price * val * this.year * 12;
      // }else if (boolean && this.$store.state.vipActiveData[3] && val >= this.$store.state.vipActiveData[3].lowerLimit) {
      //   this.isBtn = false;
      //   this.vipTotal =
      //     this.$store.state.vipActiveData[3].price * val * this.year * 12;
      // }else
      if (
        boolean &&
        this.$store.state.vipActiveData[2] &&
        val >= this.$store.state.vipActiveData[2].lowerLimit
      ) {
        this.isBtn = false
        this.vipTotal =
          this.year == 1 ? this.$store.state.vipActiveData[2].price * val * this.year * 12 * 0.9 : this.$store.state.vipActiveData[2].price * val * this.year * 12 * 0.8
      } else if (
        boolean &&
        this.$store.state.vipActiveData[1] &&
        val >= this.$store.state.vipActiveData[1].lowerLimit
      ) {
        this.vipTotal =
          this.year == 1 ? this.$store.state.vipActiveData[1].price * val * this.year * 12 * 0.9 : this.$store.state.vipActiveData[1].price * val * this.year * 12 * 0.8
        this.isBtn = false
      } else if (
        boolean &&
        this.$store.state.vipActiveData[0] &&
        val >= this.$store.state.vipActiveData[0].lowerLimit
      ) {
        this.vipTotal =
          this.year == 1 ? this.$store.state.vipActiveData[0].price * val * this.year * 12 * 0.9 : this.$store.state.vipActiveData[0].price * val * this.year * 12 * 0.8
        this.isBtn = false
      } else {
        this.vipTotal = 0
        this.isBtn = true
      }
    },
  },
}
</script>

<style lang="less" scoped>
.charge-container {
  padding: 16px;
  height: 150px;
  margin: 25px 0;
  background: rgba(243, 245, 247, 1);
  border-radius: 16px;
  border: 2px solid rgba(224, 234, 241, 1);
  display: flex;
  justify-content: space-between;
  > div {
    width: 112px;
    height: 112px;
    background-color: #fff;
    border-radius: 8px;
    padding: 22px 14px;
    text-align: center;
    h4 {
      font-size: 14px;
      font-weight: 600;
    }
    .price {
      font-size: 24px;
      font-weight: bold;
      color: rgba(59, 196, 146, 1);
    }
    .name {
      font-size: 12px;
      font-weight: 400;
      color: rgba(131, 143, 153, 1);
    }
  }
}

.package-buy {
  padding-bottom: 60px;
}

.login-btn {
  width: 160px;
  margin-right: 15px;
  background: rgba(59, 196, 146, 1);
  border-radius: 28px;
  border-color: rgba(59, 196, 146, 1);
  &:hover {
    background: rgba(59, 196, 146, 0.7);
    border-color: rgba(59, 196, 146, 0.7);
  }
}

.btn-container {
  p {
    padding-top: 10px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(131, 143, 153, 1);
  }
}
.totle {
  padding: 25px 0;
  h2 {
    font-size: 32px;
    font-weight: 600;
    color: rgba(44, 45, 58, 1);
    padding: 20px 0;
  }
}
.title {
  font-size: 20px;
  font-weight: 600;
  padding: 25px 0;
}
.tips {
  padding-left: 15px;
  font-size: 14px;
  color: #838f99;
  font-weight: 600;
}

.package-type {
  display: flex;
  width: 60%;
  padding-bottom: 30px;
  .name {
    flex: 1;
    font-size: 18px;
    font-weight: 600;
  }
  .info {
    flex: 2;
    font-size: 14px;
    color: #838f99;
    font-weight: 600;
    p {
      padding: 5px 0;
      &::before {
        content: "●";
        font-size: 12px;
      }
    }
  }
}
.paybtn {
  margin-top: 13px;
  display: flex;
  align-items: center;
  justify-content: left;
}
.infocheckbox {
  display: flex;
  align-items: center;
  justify-content: center;
}
.infocheckbox p {
  padding: 0;
  margin-left: 10px;
}
/deep/.el-dialog__body {
  height: 70vh;
  overflow: auto;
}
.reg-text p {
  line-height: 2;
  margin: 10px 0;
}

.reg-text h4 {
  font-size: 22px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(59, 196, 146, 1);
  line-height: 30px;
  text-align: center;
  margin-bottom: 32px;
  span {
    height: 50px;
    display: inline-block;
  }
}
.p-weight {
  font-weight: 550;
}
</style>
